import { LOGIN, LOGOUT } from "../types/type";

const initState = {
    token: '',
    isAuth: false
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                token: action.payload,
                isAuth: true
            }

        case LOGOUT:
            return {
                ...state,
                token: "",
                isAuth: false
            }

        default:
            return state;
    }
}

export default reducer;